/* =============================================================================
 *  eyeoo-n8n-form.js  —  <n8n-form> per Comelstile (tema Avante 14.x)
 *  Componente vanilla, zero fork dei file vendor. Logica: carica negozi →
 *  raccogli campi → POST al webhook → mostra esito. Va in assets/ e si carica
 *  via snippets/eyeoo-assets.liquid (defer, solo sulle PDP).
 * -----------------------------------------------------------------------------
 *  v2 — ALLINEAMENTO AL CONTRATTO DI GRUPPO (confermato da Spoto + L&B):
 *    • Attributo campi:  data-n8n-form--name    (standard Eye-oo, doppio trattino)
 *    • Attributo submit: data-n8n-form--action="submit"
 *    • Retrocompatibilità: gli attributi v1 (data-n8n-name / data-n8n-submit)
 *      restano supportati finché eyeoo-try-in-store.liquid non viene migrato.
 *      TODO: migrato il try-in-store, rimuovere i legacy da CONFIG.
 *    • Endpoint: già letto da data-form-url sul tag <n8n-form> (come L&B),
 *      con data-form-type come discriminante. Endpoint confermati:
 *        try_in_store            → https://n8n.eye-oo.com/webhook/odoo/try/create
 *        notify_me / not_saleable→ https://n8n.eye-oo.com/webhook/odoo/create/ticket
 * -----------------------------------------------------------------------------
 *  APERTURA MODALE — RISOLTA (riuso della modale nativa di Avante):
 *  Questo <n8n-form> vive DENTRO una <modal-window> nativa (class
 *  .product-popup-modal), aperta da un <modal-opener data-modal="#...">.
 *  Apertura/chiusura/overlay/focus-trap/ESC sono gestiti da Avante: noi non
 *  scriviamo codice per aprire il popup. Due conseguenze, già gestite qui sotto:
 *    • ModalWindow.show() SPOSTA il contenuto (con questo elemento) dentro <body>
 *      e lo rimette a posto in hide() → connectedCallback può rifirare più volte
 *      → è reso IDEMPOTENTE (guardia this._bound).
 *    • show() NON emette alcun evento di apertura → carico i negozi osservando
 *      l'attributo [open] che show() mette sulla <modal-window> (_watchOpen).
 * -----------------------------------------------------------------------------
 *  COSA RESTA DA CONFERMARE CON LUCA/VASIL:
 *    • stores  : forma del JSON di `stores/try/get`  → qui assumo [{ shop, code }]
 *    • response: forma del JSON dei webhook          → qui assumo [{ status:'OK'|'KO', message }]
 *    • storesUrl e quali negozi tornare per Comelstile (Tolmezzo/Buja/Pozzuolo)
 *  (I nomi campo della request NON sono più un TODO: contratto confermato
 *   identico su Spoto e L&B — vedi eyeoo-product-availability.liquid.)
 * -----------------------------------------------------------------------------
 *  MARKUP LIQUID ATTESO (Custom Liquid block sulla PDP):
 *    <modal-opener data-modal="#PopupModal-...">
 *      <button class="popup-button ..." aria-haspopup="dialog">…</button>
 *    </modal-opener>
 *    <modal-window id="PopupModal-..." class="product-popup-modal">
 *      <div class="product-popup-modal__content" role="dialog" aria-modal="true" tabindex="-1">
 *        <button id="ModalClose-..." class="...">×</button>            // chiusura nativa
 *        <n8n-form data-form-url="{{ endpoint }}" data-form-type="try_in_store|notify_me|not_saleable">
 *          <form novalidate>
 *            <div class="n8n-form__alerts hidden"></div>
 *            <div class="n8n-form__fields">
 *              <input  data-n8n-form--name="user[name]"  required>
 *              <input  data-n8n-form--name="user[email]" required type="email">
 *              <select data-n8n-form--name="store"></select>   // riempita da questo JS (solo try_in_store)
 *              <input  data-n8n-form--name="product_id" type="hidden" value="{{ product.id }}">
 *              <button type="button" data-n8n-form--action="submit">Invia richiesta</button>
 *            </div>
 *          </form>
 *        </n8n-form>
 *      </div>
 *    </modal-window>
 *  NB: NON mettere sul bottone la classe .popup-button--form: attiverebbe la
 *  logica nativa di auto-riapertura (cookie avante-theme:form-submitted), che
 *  qui non serve — l'esito lo gestiamo noi via fetch.
 * ============================================================================= */

(function () {
  'use strict';

  const CONFIG = {
    // --- DOM del form --------------------------------------------------------
    // Standard di gruppo + legacy v1 in coda (TODO: rimuovere i legacy dopo
    // la migrazione di eyeoo-try-in-store.liquid ai nuovi attributi).
    fieldAttrs:         ['data-n8n-form--name', 'data-n8n-name'],
    submitSelectors:    ['[data-n8n-form--action="submit"]', '[data-n8n-submit]', 'button[type="submit"]'],
    storeSelectSelector:'select[data-n8n-form--name="store"], select[data-n8n-name="store"]',
    alertsSelector:     '.n8n-form__alerts',      // box messaggi
    fieldsSelector:     '.n8n-form__fields',      // wrapper campi (nascosto su OK)

    // --- Aggancio alla modale nativa Avante ---------------------------------
    // Osservo l'attributo [open] su questo elemento per caricare i negozi
    // "on open". Su Avante lo mette ModalWindow.show() sulla <modal-window>.
    modalSelector:      'modal-window',

    // --- Endpoint lista negozi ----------------------------------------------
    storesUrl:          'https://n8n.eye-oo.com/webhook/odoo/stores/try/get', // TODO: confermare con Luca/Vasil

    // --- [Opzionale] disponibilità per negozio ------------------------------
    productTagsScriptId:null,                     // id <script> JSON coi tag prodotto, o null per saltare
    availableLabel:     'Disponibile in negozio',
    notAvailableLabel:  'Su ordinazione',

    // --- mapping della risposta "stores" (adatta ai nomi reali di Luca) -----
    storeShopKey:       'shop',                   // etichetta visibile del negozio
    storeCodeKey:       'code',                   // codice negozio (per il match tag)

    // --- cache lista negozi (cookie) ----------------------------------------
    cookieKey:          'eyeoo:try:stores',
    cookieDays:         1,
  };

  // Selettore unico per "qualsiasi campo da inviare" (standard + legacy).
  const FIELD_SELECTOR = CONFIG.fieldAttrs.map((a) => '[' + a + ']').join(', ');

  // Legge il nome-payload di un campo, provando gli attributi in ordine.
  function fieldName(el) {
    for (const attr of CONFIG.fieldAttrs) {
      const v = el.getAttribute(attr);
      if (v !== null) return v;
    }
    return null;
  }

  class N8nForm extends HTMLElement {
    connectedCallback() {
      // IDEMPOTENTE: Avante, all'apertura, sposta il contenuto della modale (e
      // quindi questo elemento) dentro <body>, poi lo rimette a posto alla
      // chiusura. Ogni spostamento rifà scattare connectedCallback sullo STESSO
      // nodo: senza questa guardia ri-agganceremmo i listener → doppio submit.
      if (this._bound) return;
      this._bound = true;

      this.url    = this.getAttribute('data-form-url');   // endpoint (dal Liquid)
      this.type   = this.getAttribute('data-form-type');  // try_in_store | notify_me | not_saleable
      this.form   = this.querySelector('form');
      this.button = null;
      for (const sel of CONFIG.submitSelectors) {
        this.button = this.querySelector(sel);
        if (this.button) break;
      }

      if (!this.form || !this.button) return;

      // Il submit nativo non deve mai partire: gestiamo noi via fetch.
      this.form.addEventListener('submit', (e) => { e.preventDefault(); e.stopPropagation(); });
      this.button.addEventListener('click', (e) => { e.preventDefault(); this.submit(); });

      this._storesLoaded = false;
      this._watchOpen();
    }

    disconnectedCallback() {
      // L'osservatore resta valido tra gli spostamenti; nessun teardown necessario.
    }

    /* --------------------------------------------------------- APERTURA MODALE */
    // Carica i negozi al PRIMO open. Avante non emette eventi: osservo [open]
    // sulla <modal-window>. Se il form non è in una modale, carico subito.
    _watchOpen() {
      const modal = this.closest(CONFIG.modalSelector);
      if (!modal) { this.loadStores(); return; }

      if (modal.hasAttribute('open')) this.loadStores();

      this._openObserver = new MutationObserver(() => {
        if (modal.hasAttribute('open')) this.loadStores();
      });
      this._openObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }

    /* ------------------------------------------------------------------ STORE */
    async loadStores() {
      if (this._storesLoaded) return;
      const select = this.querySelector(CONFIG.storeSelectSelector);
      if (!select) return;                       // niente dropdown → niente da fare
                                                 // (notify_me / not_saleable finiscono qui)

      let items = this._cookieGet();
      if (!items) {
        items = await this._fetchStores();
        if (items && items.length) this._cookieSet(items);
      }
      if (!items || !items.length) return;

      this.renderStores(select, items);
      this._storesLoaded = true;
    }

    async _fetchStores() {
      try {
        const res = await fetch(CONFIG.storesUrl);
        if (!res.ok) return null;
        return await res.json();                 // atteso: [{ shop, code }, ...]
      } catch (_) { return null; }
    }

    renderStores(select, items) {
      // [Opzionale] tag prodotto per il match disponibilità per negozio.
      let tags = [];
      if (CONFIG.productTagsScriptId) {
        const el = document.getElementById(CONFIG.productTagsScriptId);
        if (el) { try { tags = JSON.parse(el.textContent); } catch (_) {} }
      }

      select.innerHTML = '';
      items.forEach((item) => {
        const shop = item[CONFIG.storeShopKey];
        const code = item[CONFIG.storeCodeKey];

        let label = shop;
        if (CONFIG.productTagsScriptId) {
          const available = tags.includes(code);
          label = shop + ' — ' + (available ? CONFIG.availableLabel : CONFIG.notAvailableLabel);
        }

        const opt = document.createElement('option');
        opt.value = code;
        opt.textContent = label;
        select.appendChild(opt);
      });
    }

    /* ----------------------------------------------------------------- SUBMIT */
    collect() {
      const body = new FormData();
      this.querySelectorAll(FIELD_SELECTOR).forEach((el) => {
        const name = fieldName(el);
        if (name) body.set(name, el.value);
      });
      return body;
    }

    validate() {
      let ok = true;
      this.form.querySelectorAll('[required]').forEach((el) => {
        const invalid = !String(el.value || '').trim();
        el.classList.toggle('is-invalid', invalid);
        if (invalid) ok = false;
      });
      return ok;
    }

    async submit() {
      if (!this.validate()) return;
      this.button.setAttribute('disabled', 'disabled');

      try {
        const res  = await fetch(this.url, { method: 'POST', body: this.collect() });
        const data = res.ok ? await res.json() : null;   // atteso: [{ status, message }]
        this.handleResponse(Array.isArray(data) ? data : null);
      } catch (_) {
        this.handleResponse(null);
      }
    }

    handleResponse(items) {
      const alerts = this.querySelector(CONFIG.alertsSelector);
      const fields = this.querySelector(CONFIG.fieldsSelector);

      // Errore di rete / risposta non valida → riabilita e basta.
      if (!items) { this.button.removeAttribute('disabled'); return; }

      const item = items[0] || {};
      const isOk = item.status === 'OK';

      if (alerts) {
        alerts.innerHTML = '';
        if (item.message) {
          const div = document.createElement('div');
          div.className = 'alert ' + (isOk ? 'alert--success' : 'alert--error');
          div.setAttribute('role', 'status');
          div.innerHTML = item.message;
          alerts.appendChild(div);
          alerts.classList.remove('hidden');
        } else {
          alerts.classList.add('hidden');
        }
      }

      if (fields) fields.classList.toggle('hidden', isOk);  // su OK nasconde il form
      if (!isOk) this.button.removeAttribute('disabled');   // su KO riprova

      // NOTA: la versione Symmetry, in caso di KO, renderizzava anche una lista
      // di prodotti alternativi (.n8n-form__products, campi Odoo x_studio_*).
      // Omessa di proposito: dipende dal contratto KO. Riattivabile se serve.
    }

    /* ------------------------------------------------------------ COOKIE CACHE */
    _cookieGet() {
      const m = document.cookie.match(new RegExp('(?:^|; )' + CONFIG.cookieKey + '=([^;]*)'));
      if (!m) return null;
      try { return JSON.parse(decodeURIComponent(m[1])); } catch (_) { return null; }
    }

    _cookieSet(items) {
      const exp = new Date(Date.now() + CONFIG.cookieDays * 864e5).toUTCString();
      document.cookie = CONFIG.cookieKey + '=' +
        encodeURIComponent(JSON.stringify(items)) + '; expires=' + exp + '; path=/; SameSite=Lax';
    }
  }

  if (!customElements.get('n8n-form')) {
    customElements.define('n8n-form', N8nForm);
  }
})();